import React from "react";
import LangchainProcessor from "./LangchainProcessor";

const MessageParser = ({ children, actions }) => {
    const parse = async (message) => {
        const lowerCaseMessage = message.toLowerCase();
        console.log("acciones disponibles:", actions); 
        // Lógica para "consultar usuario"
        if (
            lowerCaseMessage.startsWith("ver paquetes") ||
            lowerCaseMessage.startsWith("consultar paquetes")
          ) {
            await actions.hacerConsultapaquetes(message); // 🔥 handler correcto
            return;
          }

        // Iniciar flujo de ventas
        if (lowerCaseMessage === "iniciar venta") {
            actions.iniciarVenta();
            return;
        }

        // Detectar si el flujo de ventas está activo
        if (actions.isVentaActiva()) {
            actions.manejarFlujoVenta(message);
            return;
        }

        if (lowerCaseMessage.startsWith("ver paquetes") || lowerCaseMessage.startsWith("consultar paquetes")) {
            await actions.hacerConsultapaquetes(message);
            return;
          }

        console.log(actions.isValidacionCoberturaActiva)

        if (actions.isValidacionActiva && actions.isValidacionActiva()) {
            await actions.manejarValidacionCliente(message);
            return;

        }
        // Lógica para Validar Cobertura
        if (actions.isValidacionCoberturaActiva) {
            console.log("dsfjkd")
            await actions.manejarValidacionDeCobertura(message);
            return;
        }

        // Respuesta genérica si no está en un flujo
        const previousMessages = children?.props?.state?.messages;
        const reply = await LangchainProcessor(message, previousMessages);

        if (reply.error) {
            console.error("Error en LangchainProcessor:", reply.error);
            actions.sendBotResponse(`Error ${reply.status}: ${reply.error}`);
        } else if (typeof reply === 'string') {
            actions.sendBotResponse(reply);
        } else {
            // Convierte el objeto en un string legible
            const formattedReply = JSON.stringify(reply, null, 2);
            actions.sendBotResponse(formattedReply);
        }


    };

    return (
        <div>
            {React.Children.map(children, (child) => {
                return React.cloneElement(child, {
                    parse: parse,
                    actions,
                });
            })}
        </div>
    );
};

export default MessageParser;
